const CACHE_VERSION = 1;

interface VisualCachePayload {
  readonly version: number;
  readonly vectors: Readonly<Record<string, readonly number[]>>;
}

export function loadVisualCache(packId: string): ReadonlyMap<string, readonly number[]> {
  try {
    const raw = localStorage.getItem(cacheKey(packId));
    if (!raw) return new Map();
    const parsed = JSON.parse(raw) as VisualCachePayload;
    if (parsed.version !== CACHE_VERSION || !parsed.vectors) return new Map();
    return new Map(Object.entries(parsed.vectors).filter(([, vector]) => Array.isArray(vector) && vector.length > 0));
  } catch {
    return new Map();
  }
}

export function saveVisualCache(packId: string, vectors: ReadonlyMap<string, readonly number[]>): void {
  try {
    const payload: VisualCachePayload = {
      version: CACHE_VERSION,
      vectors: Object.fromEntries(vectors)
    };
    localStorage.setItem(cacheKey(packId), JSON.stringify(payload));
  } catch {
    // Visual search remains functional for the current session when storage is unavailable.
  }
}

function cacheKey(packId: string): string {
  return `needle.visual-preview.${CACHE_VERSION}.${packId}`;
}
